import React, { Component, createRef, forwardRef, useImperativeHandle } from "react";
import { View, Image, TextInput, Text, FlatList, ActivityIndicator} from "react-native-web";
import { ParallaxProvider, ParallaxBanner, Parallax } from 'react-scroll-parallax';
import { AnimatePresence, motion, useScroll, useTransform, useMotionValue } from 'framer-motion';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import ItemSearchMobile from '../home/ItemSearchMobile';
import ZoomPreview from '../home/ZoomPreview';

import momentStore from '../../../store/momentStore';
import pageStore from '../../../store/pageStore';

import i18n from "../../../i18n";

import Footer from "../../footer/Footer";


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;



let titleFontSize30, titleFontSize25, titleFontSize22, titleFontSize20, titleFontSize19, titleFontSize18, titleFontSize17, titleFontSize16, titleFontSize15, titleFontSize13, titleFontSize;

if (viewportWidth > 1400)
{
   titleFontSize = 40;
   titleFontSize30 = 30;
   titleFontSize25 = 25;
   titleFontSize22 = 22;
   titleFontSize20 = 20;
   titleFontSize19 = 19;
   titleFontSize18 = 18;
   titleFontSize17 = 17;
   titleFontSize16 = 16;
   titleFontSize15 = 15;
   titleFontSize13 = 13;
}
else if (viewportWidth > 1200)
{
   titleFontSize = 35;
   titleFontSize30 = 26;
   titleFontSize25 = 22;
   titleFontSize22 = 20;
   titleFontSize20 = 19;
   titleFontSize19 = 18;
   titleFontSize18 = 17;
   titleFontSize17 = 16;
   titleFontSize16 = 15;
   titleFontSize15 = 14;
   titleFontSize13 = 12;
}
else
{
   titleFontSize = 30;
   titleFontSize30 = 24;
   titleFontSize25 = 19;
   titleFontSize22 = 17;
   titleFontSize20 = 18;
   titleFontSize19 = 17;
   titleFontSize18 = 16;
   titleFontSize17 = 15;
   titleFontSize16 = 14;
   titleFontSize15 = 13;
   titleFontSize13 = 11;
}


const NUM_VISIBLE_ITEMS = 4;
const ARROW_WIDTH = 10;
const ITEM_SPACING = 10;


class SearchPageMobile extends Component {

    constructor(props) {

          super(props);

          this.gridRef = React.createRef();

          let numColumns, factor;
          if (viewportWidth > viewportHeight)
          {
             numColumns = 2;
             factor = 0;
          }
          else
          {
             numColumns = 2;
             factor = 32;
          }


         const itemWidth = Math.floor((viewportWidth-factor) / numColumns);


     	   this.state = {
           itemWidth: itemWidth,
           numColumns: numColumns,
           hoveredItem: null,
           hoverPosition: null, // { x: 0, y: 0 },
           pendingItem: null,
           pendingPosition: null,
           viewportWidth: window.innerWidth,
           viewportHeight: window.innerHeight,
     	   };



     }




    componentDidMount(){

	  }

	  UNSAFE_componentWillMount(){

	  }

	  UNSAFE_componentWillUnmount(){

	  }





  render() {

    const { itemWidth, numColumns } = this.state;


    return (

        <div style={{position: 'fixed', zIndex: 9, top: 0, bottom: 0, left: 0, backgroundColor: '#f3f5f8', width: this.state.viewportWidth+'px', height: this.state.viewportHeight+'px'}}>


              {this.props.queryResults.length === 0 &&
                <div style={{position: 'relative', width: this.state.viewportWidth+'px', height: this.state.viewportHeight+'px',}}>

                    <div style={{position: 'relative', width: this.state.viewportWidth+'px', height: this.state.viewportHeight+'px', marginTop: '70px', overflow: 'auto'}}>

                            <div style={{width: this.state.viewportWidth+'px'}}>
                                <div style={{width: (this.state.viewportWidth*0.8)+'px', margin: 'auto'}}>
                                        <View style={{width: (this.state.viewportWidth*0.8)+'px', height: (this.state.viewportHeight*0.7)+'px',
                                                      alignItems: 'center', justifyContent: 'center'}}>

                                            <div>
                                              <div style={{width: '80px', margin: 'auto', alignSelf: 'center'}}>
                                                  <img src={'/img/search_icon_2.png'} style={{width: '80px', height: '80px'}}/>
                                               </div>

                                               <div style={{textAlign: 'center', fontSize: titleFontSize25+'px', marginTop: 20, opacity: 1, color: '#555'}}>
                                                    {i18n.t('No_results_found')}
                                               </div>
                                            </div>


                                        </View>



                                        <div style={{height: (this.state.viewportHeight*0.3)+'px'}}/>


                                        <Footer/>
                                </div>
                            </div>

                        </div>
                  </div>
              }


              {this.props.queryResults.length > 0 &&
                <div style={{position: 'relative', width: this.state.viewportWidth+'px', height: this.state.viewportHeight+'px'}}>

                    <div style={{position: 'relative', width: this.state.viewportWidth+'px', height: (this.state.viewportHeight-70)+'px', marginTop: '70px', overflow: 'auto', overflowX: 'hidden'}}>

                          <div style={{width: (this.state.viewportWidth-20)+'px', margin: 'auto', marginTop: '20px'}}>
                              <div style={{color: '#111', fontSize: titleFontSize17+'px'}}>{i18n.t('Search_results')}: {this.props.queryResults.length}</div>
                          </div>



                          <div style={{width: this.state.viewportWidth+'px', marginTop: '30px'}} >



                                        <div style={{position: 'relative', width: this.state.viewportWidth+'px'}}>


                                               <div ref={this.gridRef}
                                                style={{
                                                  padding: `0 ${ARROW_WIDTH}px`,
                                                  display: 'grid',
                                                  gridTemplateColumns: `repeat(${numColumns}, 1fr)`,
                                                }}>
                                                {this.props.queryResults.map((item, index) => (
                                                  <div key={index} style={{marginBottom: '10px'}}>
                                                      <ItemSearchMobile
                                                          item={item}
                                                          width={itemWidth}
                                                          isLast={index === this.props.queryResults.length - 1}
                                                        />
                                                  </div>
                                                ))}
                                              </div>


                                         </div>


                                         <div style={{height: '200px'}}/>

                                         <Footer/>



                          </div>

                    </div>

                </div>
              }





       </div>

    )
  }
}





export default SearchPageMobile;
